import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

export function useScrollToQueryParam() {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const id = searchParams.get('scrollToId');
        if (!id) return;

        let attempts = 0;
        const maxAttempts = 10; // Try for a few seconds
        const interval = 300; // Check every 300ms

        const checkForElement = () => {
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                element.focus();

                // Remove `scrollToId` from the URL without adding history entry
                if (searchParams.get('scrollToId')) {
                    setSearchParams(
                        (prevParams) => {
                            const newParams = new URLSearchParams(prevParams);
                            newParams.delete('scrollToId');
                            return newParams;
                        },
                        { replace: true }
                    );
                }
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkForElement, interval);
            }
        };

        checkForElement(); // Start checking for the element
    }, [searchParams]);

    return null;
}
